export { default } from "./logActivitySubmissionError";
